export default [
  /**
   * 绑定手机号页面
   * @query.docId 医生id；如有，显示医生信息
   */
  {
    path: '/account/bind',
    component: () => import('../pages/account/bind')
  },
  /**
   * query
   * **** cid
   * **** mobile
   * **** captcha
   */
  {
    path: '/account/register',
    component: () => import('../pages/account/register')
  },
  {
    path: '/account/perfect-info',
    component: () => import('../pages/account/perfect-info')
  }
]



// WEBPACK FOOTER //
// ./src/router/account.js